import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import { platformBrowser } from '@angular/platform-browser';
import { redirectLegacyUrls } from './app/utils/legacy-url-redirects';

if (environment.production) {
  enableProdMode();
}

if (!redirectLegacyUrls()) {
  platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
}
